import notify from '~/utils/notify';

  export default function messageSocket(message, syncMessageReceived, actualNotification){
  console.info(`Message socket received ${message.event_type}`);
  if (message.event_type === 'MESSAGE_RECEIVED') {
    syncMessageReceived().then(() => { 
    notify({ message: `Nova mensagem!`, type: 'success', actualNotification: actualNotification});
    });
  }
}